import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import CtaButton from "./CtaButton";

const NAV = [
  { label: "Home", to: "/", id: "home", end: true },
  { label: "Services", to: "/services", id: "services" },
  { label: "How It Works", to: "/how-it-works", id: "how-it-works" },
  { label: "About", to: "/about", id: "about" },
  { label: "Contact", to: "/contact", id: "contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-white/10 bg-navy/95 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link
          to="/"
          data-testid="header-logo-link"
          aria-label="Web Pilot home"
        >
          <Logo onDark />
        </Link>

        <nav
          className="hidden items-center gap-7 md:flex"
          data-testid="header-nav"
          aria-label="Main navigation"
        >
          {NAV.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              end={item.end}
              data-testid={`nav-link-${item.id}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-white" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <CtaButton to="/contact" testId="nav-cta-button" className="px-4 py-2 text-sm">
            Get a Free Preview
          </CtaButton>
        </div>

        <button
          type="button"
          className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 md:hidden"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="header-mobile-menu-button"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-white/10 bg-navy px-4 pb-6 pt-2 md:hidden"
          data-testid="mobile-nav"
          aria-label="Mobile navigation"
        >
          {NAV.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              end={item.end}
              data-testid={`mobile-nav-link-${item.id}`}
              className={({ isActive }) =>
                `block py-3 text-base font-medium transition-colors ${
                  isActive ? "text-white" : "text-slate-300"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <div className="pt-3">
            <CtaButton
              to="/contact"
              testId="mobile-nav-cta-button"
              className="w-full"
            >
              Get a Free Preview
            </CtaButton>
          </div>
        </nav>
      )}
    </header>
  );
}
